import React from "react";
import "./Gallery.css";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import photo1 from "../images/gallery/photo1.webp";
import photo2 from "../images/gallery/photo2.webp";
import photo3 from "../images/gallery/photo3.webp";
import photo4 from "../images/gallery/photo4.webp";
import photo5 from "../images/gallery/photo5.webp";
import photo6 from "../images/gallery/photo6.webp";
import photo7 from "../images/gallery/photo7.webp";
import photo8 from "../images/gallery/photo8.webp";
import photo9 from "../images/gallery/photo9.webp";
import photo10 from "../images/gallery/photo10.webp";
import photo11 from "../images/gallery/photo11.webp";
import photo12 from "../images/gallery/photo12.webp";
import photo13 from "../images/gallery/photo13.webp";
import photo14 from "../images/gallery/photo14.webp";
import photo15 from "../images/gallery/photo15.webp";
import photo16 from "../images/gallery/photo16.webp";
import photo17 from "../images/gallery/photo17.webp";
import photo18 from "../images/gallery/photo18.webp";

// Every derivative is 1200x800 (see scripts/optimize-images.mjs). The width and
// height attributes below only reserve the right aspect ratio while the image
// loads — owl.carousel.css sets width: 100% on the rendered element.
const photos = [
	photo1,
	photo2,
	photo3,
	photo4,
	photo5,
	photo6,
	photo7,
	photo8,
	photo9,
	photo10,
	photo11,
	photo12,
	photo13,
	photo14,
	photo15,
	photo16,
	photo17,
	photo18,
];

function Gallery() {
	return (
		<section id="gallery">
			<div className="title">
				<h1>Galerie</h1>
			</div>
			<div className="gallery">
				<div>
					<OwlCarousel
						className="owl-theme"
						margin={10}
						responsive={{
							0: {
								items: 1,
							},
							650: {
								items: 2,
							},
							1100: {
								items: 3,
							},
							1700: {
								items: 4,
							},
						}}
					>
						{photos.map((photo, index) => (
							<div className="item" key={index}>
								<img
									src={photo}
									alt={`Sediul RafizioMed ${index + 1}`}
									width={1200}
									height={800}
									loading="lazy"
								/>
							</div>
						))}
					</OwlCarousel>
				</div>
			</div>
		</section>
	);
}

export default Gallery;
